export default function TramesSaisiesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('trames.saisies');
}

TramesSaisiesConfiguration.$inject = ['$translatePartialLoaderProvider'];
